import { z } from 'zod'
import { quoteDtoSchema } from '@/modules/sales/clients/types/Quote.ts'
import { productTypeSchema } from '@/modules/sales/clients/types/articleTypes/Common.ts'
import { addressSchema } from '@/modules/sales/clients/components/assignArticle/components/supplierAutomotive/assignMotorbikeArticles/assignArticleFormSchema.ts'

export const creditUnpaySchema = z.object({
  id: z.string(),
  registerNumber: z.string(),
  largeJson: z.object({
    cost: z.string(),
    imei: z.string(),
    rate: z.string(),
    model: z.string(),
    client: z.string(),
    profit: z.string(),
    quotes: z.array(quoteDtoSchema),
    initial: z.string(),
    rifImage: z.string(),
    supplierId: z.string(),
    idCardImage: z.string(),
    productType: productTypeSchema,
    rentability: z.string(),
    bodySerial: z.string(),
    extraPayment: z.string(),
    initialTotal: z.string(),
    invoiceImage: z.string(),
    policyNumber: z.string(),
    totalPayment: z.string(),
    unpaidCredit: z.boolean(),
    invoiceNumber: z.string(),
    additionalCost: z.string(),
    branchOfficeId: z.number(),
    dayCreditBegan: z.string(),
    registerNumber: z.string(),
    paymentByQuotes: z.string(),
    discountedCredit: z.string(),
    insuranceProvider: z.string(),
    creditBeforeAssign: z.string(),
    driverLicenseImage: z.string(),
    insurancePolicyImage: z.string(),
    isPromotionCreditLimit: z.boolean(),
    originCertificateImage: z.string(),
    letterResidence: z.string().optional(),
    medicalCertificateBackImage: z.string(),
    promotionDiscountPercentage: z.string(),
    medicalCertificateFrontImage: z.string(),
    originCertificateNumber: z.string().optional(),
    originCertificateDate: z.string().optional(),
    engineSerial: z.string().optional(),
    chassisSerial: z.string().optional(),
    seats: z.string().optional(),
    axes: z.string().optional(),
    color: z.string().optional(),
    taraKg: z.string().optional(),
    loadCapacityKg: z.string().optional(),
    vehicleClass: z.string().optional(),
    clientAddress: addressSchema.optional(),
    workAddress: addressSchema.optional()
  }),
  clientName: z.string(),
  clientId: z.string(),
  createdAt: z.string()
})

export type CreditUnpay = z.infer<typeof creditUnpaySchema>
